import { ENV, THEME } from 'reactor/common';

const { UNIT } = THEME;
const { NODE_ENV } = process.env;

export default {
  CAMPAIGN: {
    LINK: 'link',
    WIDGET: 'widget',
  },
  CONTAINERS: [
    'dictionary',
    'experiences',
    'stories',
  ],
  CONDITIONS_AFFILIATES: 'https://imgs-akamai.mnstatic.com/tools/genericimages/e6da52a36c519fb633c5ab6ddbc72ea5fad9502babc41188a59878c53c82a998.pdf',
  COOKIE_DOMAIN: NODE_ENV === 'development' ? 'localhost' : '.minube.com',

  DEFAULT_COUNTRY: 'España',
  DEFAULT_DOCUMENT: 'DNI',


  ENUMS: {
    CAMPAIGN_TYPES: ['link', 'widget'],
  },

  FETCH_PROPS: {
    endpoint: ENV.IS_PRODUCTION ? 'api.minube.com' : 'staging.api.minube.com',
    secure: true,
  },

  HTTP: {
    METHOD: {
      POST: 'POST',
      UPDATE: 'UPDATE',
      DELETE: 'DELETE',
    },
  },

  LANGUAGE: 'es-ES',
  LANGUAGES: [
    'es-ES',
    'es-MX',
    'en-EN',
    'fr-FR',
    'it-IT',
    'pt-BR',
    'pt-PT',
  ],
  LAYOUT: {
    ASIDE: {
      WIDTH: UNIT * 30,
    },
    CONTENT: {
      MAX_WIDTH: UNIT * 80,
      MIN_WIDTH: UNIT * 32,
      WIDTH: UNIT * 52,
      FULL_WIDTH: 1025,
    },
    HEADER: {
      HEIGHT: UNIT * 6,
    },
    WRAPPER: {
      WIDTH: 1280,
    },
    LOGO: 'https://cdn.mnstatic.com/1/svg/logo/icon_minube_sidebar.svg',
    LOGO_AGENCY: 'https://imgs-akamai.mnstatic.com/tools/genericimages/0f791249a8f2c5ce019a8d5d03cba3554eae2c268878c99ae559469be84c2ca2.png',
  },
  LOGOUT: 'logout',

  MESSAGE: {
    TYPE: {
      ERROR: 'error',
      INFO: 'info',
    },
  },

  NEW: 'new',

  ROUTER: {
    stories: ['stories', 'story'],
  },

  START: 'start',
  STATE: {
    DEFAULT: [
      'pending',
      'processing',
      'completed',
      'refused',
      'cancelled',
      'active',
      'inactive',
    ],

    EXPERIENCE: ['active', 'inactive'],

    FEE: ['percentage', 'amount'],

    CANCELLED_CUSTOMER: 'cancelledByCustomer',
    CANCELLED_PROVIDER: 'cancelledByProvider',
    COMPLETED: 'completed',
    NOT_PAID: 'notPaid',
    PENDING_TRANSFER: 'pendingTransfer',
    REFUSED: 'refused',
    UNAUTHORIZED: 'unauthorized',
  },

  CAMPAIGN_MODE: {
    DYNAMIC: 'dynamic',
    STATIC: 'static',
  },

  PERCENTAGE: '%',

  STORAGE: {
    AFFILIATE: 'minube:affiliate:authorization',
    AGENCY: 'minube:agency:authorization',
    CODE: 'minube:code',
    JEFFREY: 'minube:jeffrey',
  },

  URL: {
    ACTIVITY: 'https://www.minube.com/actividades',
    ACTIVITY_SEARCH: ENV.IS_PRODUCTION
      ? 'https://www.minube.com/activity-search'
      : 'https://nova.minube.com/activity-search',
    AFFILIATE_SIGNUP: '/affiliate/signup',
    AGENCY_SIGNUP: '/agency/signup',
    AGENCY: '/agency',
    BOOK: ENV.IS_PRODUCTION ? 'https://book.minube.com' : 'http://dev.book.minube.com',
  },
  PRIVATE_AREA: ENV.IS_PRODUCTION ? 'https://book.minube.com' : 'http://dev.book.minube.com',
};
